import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as IconCloud } from '../../icons/cloud-sad.svg';
import * as StyledError from './error.styles';

interface Props {
	heading?: string;
	subText?: string;
}

const Error: FC<Props> = ({ heading = 'error.error-heading', subText = 'error.error-subtext' }) => {
	const { t } = useTranslation('common');
	return (
		<StyledError.Wrapper>
			<IconCloud />
			<StyledError.Heading>{t(heading)}</StyledError.Heading>
			<StyledError.Text>{t(subText)}</StyledError.Text>
		</StyledError.Wrapper>
	);
};

export default Error;
